import { render } from "./AccordionV2.vue?vue&type=template&id=6382a0e7&scoped=true"
import script from "./AccordionV2.vue?vue&type=script&lang=js"
export * from "./AccordionV2.vue?vue&type=script&lang=js"

import "./AccordionV2.vue?vue&type=style&index=0&id=6382a0e7&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6382a0e7"]])

export default __exports__